import { Component, OnInit,OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
;

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';
import { NgForm } from '@angular/forms';
import {  ElementRef, Renderer2  } from '@angular/core';

@Component({
  selector: 'echexpayment-create-cheque',
  templateUrl: './create-cheque.component.html',
  styleUrls: ['./create-cheque.component.css']
})
export class CreateChequeComponent implements OnInit, OnDestroy {
  @ViewChild('e') e: NgForm;

	  public enterCheque : any={'check_recurrent_value':''};
    busy: Subscription;
    public name :string;
    public token :string;
    public id :string;
    public pay_to_the_order_of :string;
    public amountInWords :string;
    
    public erouting_number :string;
    public eaccount_number :string;
    public econfirm_account_number :string;
    public signature_enable_edit : boolean = false;
    public RecurringEnable : boolean = false;
    public today_date : Date;
    public bankname  : string;
    public bankaddress : string;
    public bankcity : string;
    public bankzip: string;
    public echeque_signature: string;
    public checkRouting: string;
    public checkRoutingno: string;
	
	public validationName: boolean = false;
	public validationEmail: boolean = false;
	public invalidEmail: boolean = false;

	public validationAddess: boolean = false;
	public validationCity: boolean = false;
	public validationState: boolean = false;
	public validationZip: boolean = false;
  
	public validationCheck_number: boolean = false;
	public validationCheck_amount: boolean = false;
	public validationMemo: boolean = false;
	public validationRouting_number= false;
	public validationAccount_number: boolean = false;
	public validationConfirm_account_number: boolean = false;
	public match: boolean = false;
	public minAccountLength: boolean = false;
  public formTouched : boolean = false;
  public characterLimitReached : boolean = false;
  public NamecharacterLimitReached: { [key: string]: boolean } = {};
  public showWarning: boolean = false;

	constructor(protected router: Router, private elementRef: ElementRef, protected route: ActivatedRoute,private renderer: Renderer2,  private toastr: ToastrService, protected userService:UserService, protected echexpaymentService :EchexpaymentService, protected localStorageService: LocalstorageService) { 
	
		this.router = router;
		var currentUser = this.localStorageService.getData("currentUserToken");
		this.token = currentUser && currentUser.data.user_token;
		
		let userDetails = this.localStorageService.getData("currentUser");
		this.id = userDetails._id;
		this.pay_to_the_order_of = userDetails.business_name ? userDetails.business_name : (userDetails.first_name + ' ' +  userDetails.last_name);
        
		this.today_date =  new Date();
	}

  ngOnDestroy() {
    this.toastr.clear();
  }
  
	ngOnInit() {
	}

  ngAfterViewInit() {
		this.renderer.selectRootElement('#Focus_name').focus();
	}
	  
	//setAmountValue
  setAmountValueForBankAuth(amount){
		if(amount) {
			this.enterCheque.amount = parseFloat(amount).toFixed(2);
		}      
  }
	checkCharacterLimit(event: any) {
      const maxTextLength = 20; // Maximum text length of 20 characters
      const inputChar = event.key;
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
      const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
    
      if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
        return;
      }
      const inputValue = event.target.value;
      
      if (inputValue.length >= maxTextLength) {
        if (allowedKeys.indexOf(inputChar) === -1) {
        this.characterLimitReached = true; // Set the validation flag to true to show the warning message
        setTimeout(() => {
          this.characterLimitReached = false; // Hide the warning message after 3 seconds
        }, 3000);
        event.preventDefault(); // Prevent entering the exceeded character
        }
      }
	}
  
  //Length validate  
  NameCharacterLimit(event: any, fieldName: string, max_length:number) {
    const maxTextLength = max_length; // Maximum text length of 20 characters
    const inputChar = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
    const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter

    if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
        return;
    }

    const inputValue = event.target.value;

    if (inputValue.length >= maxTextLength) {
        if (allowedKeys.indexOf(inputChar) === -1) {
            this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
            setTimeout(() => {
            this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
            }, 3000);
            event.preventDefault(); // Prevent entering the exceeded character
        }
    }
}

isNameLimitReached(fieldName: string): boolean {
    return this.NamecharacterLimitReached[fieldName];
}
  
  
	@ViewChild('submitButton') submitButton: ElementRef;
  @ViewChild('Focus_Selectrecuring') focusSelectRecuring: ElementRef;
  moveNext(nextInput: HTMLInputElement, checkbox : number) {
    if(checkbox === 2){
      const saveButton = document.getElementById('submitButton') as HTMLElement;
      if (saveButton) {
        saveButton.focus();
        saveButton.click();
      }
    } else{
      nextInput && nextInput.focus();
    }
  }
   
  limitDecimalLength(inputElement: HTMLInputElement) {
    const regex = /^\d{0,9}(\.\d{0,2})?$/;
    const inputValue = inputElement.value;
    
    if (!regex.test(inputValue)) {
      inputElement.value = inputValue.slice(0, -1);
    }
  }
  

  focusFirstInvalidControlPlus(): void {
    const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
    if (firstElementWithErrors) {
        firstElementWithErrors.focus();
    }
}
  
  

	checkSignature(event: any){
		    if(event.target.checked){
            this.signature_enable_edit = true;
        } else{
            this.signature_enable_edit = false;
        }
	}



  checkRecurring(event: any){
		    if(event.target.checked){
            this.RecurringEnable = true;
            if (this.focusSelectRecuring) {
              this.moveNext(this.focusSelectRecuring.nativeElement, null);
            }
        }else{
            this.RecurringEnable = false;
            const saveButton = document.getElementById('submitButton') as HTMLElement;
            if (saveButton) {
              saveButton.focus();
              saveButton.click();
            }
        }
	}

  
    validateInput(event: any) {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
      
        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
          // Allow the default behavior for certain keys
          return;
        }
      
        if (!/^\d+$/.test(event.key)) {
          // Prevent input if it's not a digit
          event.preventDefault();
        }
      }
      
      DisallowZero(event: any) {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
      
        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
          // Allow the default behavior for certain keys
          return;
        }
      
        const inputValue = event.target.value;
        const caretStart = event.target.selectionStart;
        const caretEnd = event.target.selectionEnd;
        const modifiedValue = inputValue.slice(0, caretStart) + event.key + inputValue.slice(caretEnd);
        
        if (modifiedValue !== '' && !/^\d*\.?\d*$/.test(modifiedValue)) {
          this.showWarning = false; // Hide the warning message
          event.preventDefault(); // Prevent invalid input
          return;
        }
        const regex = /^\d{0,9}(\.\d{0,2})?$/;
        const maxValue = 999999999;
        if (!regex.test(modifiedValue) || parseFloat(modifiedValue) > maxValue) {
          if (parseFloat(modifiedValue) > maxValue) {
            this.showWarning = true;
            setTimeout(() => {
              this.showWarning = false;
            }, 3000);
            event.preventDefault();
          }
          event.preventDefault();
        } 

        // if (!/^[0-9]*\.?[0-9]*$/.test(modifiedValue)) {
        //   // Prevent input if it's not a valid digit or decimal value with a maximum of two decimal places
        //   event.preventDefault();
        // }
      }
      
      
  
  amountToWords(value) {
    if (value === null || value === undefined) {
      this.amountInWords = '';
    } else {
      const dollars = Math.floor(value);
      const cents = Math.round((value - dollars) * 100);
      let centsText = '';
  
      if (cents !== 0) {
        centsText = `${cents}/100`;
      } else {
        centsText = `00/100`;
      }
  
      this.amountInWords = `${this.echexpaymentService.toWords(dollars)}`;
  
      if (centsText) {
        this.amountInWords += ` and ${centsText} Cents`;
      }

    }
  }
  
	//setAmountValue
    setAmountValue(amount){
      if(amount) {
        this.enterCheque.amount = parseFloat(amount).toFixed(2);
      }
    }

    // get routing info
	getRoutingInfo(routing_number){
        if(routing_number && routing_number.length >=9) {
		 let data = {
		  user_token:this.token,
          token:this.id,
		  id:this.id,
		  routing_number :routing_number
		}
		let responseData = <any>{};
		this.userService.getRoutingInfoApi(data).subscribe(
		 response => {
			responseData = response;
			this.bankname = responseData.data.name;
			this.bankaddress = responseData.data.address;
			this.bankcity = responseData.data.city;
			this.bankzip = responseData.data.zip;
        if( responseData.status === 'error'){
          this.checkRouting = responseData.status;
          this.checkRoutingno = 'error';
        } else{
          this.checkRouting = '';
          this.checkRoutingno = 'Success';
        }
		 }, 
		 error => {
			responseData = error;
            this.toastr.error(responseData.error.message, 'Failed!');
		 }
		); 
		}
    }
   

    eventHandler(){
        this.validationName = false;
        this.validationEmail = false;
        this.invalidEmail = false;

        this.validationAddess = false;
        this.validationCity = false;
        this.validationState = false;
        this.validationZip = false;
      
        this.validationCheck_number = false;
        this.validationCheck_amount = false;
        this.validationMemo = false;
        this.validationRouting_number= false;
        this.validationAccount_number = false;
        this.validationConfirm_account_number = false;
        this.match = false;
        this.minAccountLength = false;
    }

    saveCheque(data){ 
        this.focusFirstInvalidControlPlus();   //focus field
        this.formTouched = true;
        if(data.valid && this.checkRoutingno === "Success"){ 
          if (data.value.checking_account_number !== data.value.confirm_account_number) {
            return;
          }

        let model: any = data.value;
        model.user_token = this.token;
        model.token = this.id;
        model._id = this.id;
        model.cheque_signature =  model.name;
        model.signature_enable = !this.signature_enable_edit;
        model.check_recurrent_enable = this.RecurringEnable;
        model.to_name =  this.pay_to_the_order_of;
		    let responseData = <any>{};
        this.busy = this.echexpaymentService.saveChequeApi(model).subscribe(
             response => {
                this.formTouched = false;
				        responseData = response;
                this.e.reset();
                // this.enterCheque = "";
                // // model = "";
                
                 this.amountInWords = "";
                 this.bankname = "";
                this.bankaddress = "";
                this.bankcity  = "";
                this.bankzip = "";
                // this.amountInWords = '';
                this.signature_enable_edit = false;
                this.today_date =  new Date();
                this.toastr.success('Check Created successfully', 'Success!');
             }, 
             error => {
               responseData = error;
               this.toastr.error(responseData.error.message, 'Failed!');
             }
          ); 
        }
    }


    checkFontSize(text: string): string {
      const container = document.createElement('div');
      container.style.visibility = 'hidden';
      container.style.position = 'absolute';
      container.style.width = 'fit-content';
      container.style.whiteSpace = 'nowrap';
      container.style.fontSize = '11px'; // Set your initial font size here
    
      container.textContent = text;
    
      const maxWidth = this.elementRef.nativeElement.offsetWidth;
      while (container.offsetWidth > maxWidth && parseFloat(container.style.fontSize) > 0) {
        const currentFontSize = parseFloat(container.style.fontSize);
        container.style.fontSize = (currentFontSize - 1) + 'px';
      }
    
      return container.style.fontSize;
    }
    
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/create-cheque/create-cheque.component.ts